import { all } from 'redux-saga/effects';

import relatorioSaga from './relatorio/saga';

export default all([relatorioSaga]);
